<h2 mat-dialog-title class="filter-dialog-header" translate>{{filter.name}}</h2>
<mat-form-field style="width:300px" >
  <mat-select [(value)]="selected">
    <mat-option value="!==">{{"A2FILTER.NOT_CONTAINING" | translate}}</mat-option>
    <mat-option value="===">{{"A2FILTER.CONTAINING" | translate}}</mat-option>
  </mat-select>
</mat-form-field>

<mat-dialog-content class="mat-typography">
  <mat-list>
    <ng-container [ngSwitch]="filter.type">
      <app-filter-list *ngSwitchCase="FilterType.List" [filter]='filter' [filterForm]="filterForm" (filterChange)="onFilterChange($event)"></app-filter-list>
      <app-filter-multi *ngSwitchCase="FilterType.Multi" [filter]='filter' [filterForm]="filterForm" (filterChange)="onFilterChange($event)"></app-filter-multi>
      <app-filter-input *ngSwitchCase="FilterType.Input" [filter]='filter' [filterForm]="filterForm" (filterChange)="onFilterChange($event)"></app-filter-input>
      <app-filter-date *ngSwitchCase="FilterType.DateRange" [filter]='filter' [filterForm]="filterForm" (filterChange)="onFilterChange($event)"></app-filter-date>
    </ng-container>
  </mat-list>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close tabindex="-1" >{{"A2FILTER.CANCEL" | translate}}</button>
  <button mat-button  type="submit" form="formFilter" color="primary" >{{"A2FILTER.APPLY" | translate}}</button>
</mat-dialog-actions>

